import styled from 'styled-components';

const desktop = '(min-width: 769px)';

const ContainerStyled = styled.div`
  background-color: #2d1540;
  position: relative;
  color: #fff;
  width: 100%;
  padding: 0 calc(100vw - 95%) 40px;

  ${({ gradient }) =>
    gradient &&
    `
      padding: 48px calc(100vw - 95%) 40px;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 8px;
        background: linear-gradient(
          269.84deg,
          #c348ea 0.11%,
          #7212e8 45.3%,
          #4e018d 99.84%
        );
      }
    }
  `}
`;

const InnerContentStyled = styled.div`
  width: 100%;
  display: grid;
  margin: 0 auto;
  grid-auto-flow: row;

  @media ${desktop} {
    max-width: 1280px;
    column-gap: 3%;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    row-gap: 40px;
  }

  > svg {
    grid-row: 1;
    grid-column: 1;
    justify-self: center;
    margin-bottom: 50px;

    @media ${desktop} {
      justify-self: unset;
      margin-bottom: unset;
    }
  }
`;

const SocialNetworks = styled.div`
  justify-self: center;
  text-align: center;
  width: 220px;
  grid-row: 6;
  grid-column: 1;
  margin-top: 50px;

  @media ${desktop} {
    justify-self: unset;
    text-align: unset;
    grid-row: 1;
    grid-column: 4;
    margin-top: unset;
  }

  > p {
    text-align: center;
    margin-bottom: 16px;

    @media ${desktop} {
      text-align: left;
      margin-bottom: 10px;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > a {
    display: flex;
    align-items: center;
  }

  svg {
    width: 21px;
  }
`;

export { ContainerStyled, SocialNetworks, SocialIcons, InnerContentStyled };
